import { AppCatalogCouponTemplateService } from "../resource";

const AppCatalogCouponTemplateModule = {
    namespaced: true,
    state: {
        list: [],
        total: 0,
        loading: false,
        error: null,
        current: null
    },
    mutations: {
        SET_LIST(state, data) {
            state.list = data;
        },
        SET_TOTAL(state, total) {
            state.total = total;
        },
        SET_LOADING(state, val) {
            state.loading = val;
        },
        SET_ERROR(state, err) {
            state.error = err;
        },
        SET_CURRENT(state, item) {
            state.current = item;
        }
    },
    actions: {
        async fetchList({ commit }, params) {
            commit("SET_LOADING", true);
            commit("SET_ERROR", null);
            try {
                const res = await AppCatalogCouponTemplateService.list(params);
                const body = res.data || {};
                commit("SET_LIST", body.data || []);
                commit("SET_TOTAL", body.total || 0);
            } catch (err) {
                commit("SET_LIST", []);
                commit("SET_ERROR", err);
            } finally {
                commit("SET_LOADING", false);
            }
        },
        async fetchOne({ commit }, id) {
            commit("SET_LOADING", true);
            commit("SET_ERROR", null);
            try {
                const res = await AppCatalogCouponTemplateService.get(id);
                commit("SET_CURRENT", (res.data && res.data.data) ? res.data.data : null);
            } catch (err) {
                commit("SET_CURRENT", null);
                commit("SET_ERROR", err);
            } finally {
                commit("SET_LOADING", false);
            }
        },
        create(_, payload) {
            return AppCatalogCouponTemplateService.create(payload);
        },
        update(_, { id, payload }) {
            return AppCatalogCouponTemplateService.update(id, payload);
        },
        remove(_, id) {
            return AppCatalogCouponTemplateService.remove(id);
        }
    },
    getters: {
        list: state => state.list,
        total: state => state.total,
        loading: state => state.loading,
        error: state => state.error,
        current: state => state.current
    }
};

export default AppCatalogCouponTemplateModule;
